var Schools = {

    bindSearchSelect: function() {
        $('.school-search').select2({
          ajax: {
            url: '/soladmin/schools/ajax',
            placeholder: 'Search by Last Name',
            dataType: 'json',
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                page: params.page
              };
            },
            results: function (data, page) {
                return { results: data.results };
            },
          },
          minimumInputLength: 3
        }).on('select2:select', function(e) {
            window.location.href = '/soladmin/schools/' + $(this).select2('data')[0].id + '/edit/';
        });
    }
};